// Combine-bars feature constants (the bar chart's counterpart to the pie
// chart's combine-segments control).

// Bars kept before the rest collapse into "Others", when the user hasn't picked
// a number. 16 is what a report card fits with "Others" still in view: the
// card's viz-area is 480px with 16px bottom padding, 16 bars render at 437px
// and the Others bar at 27px (its trailing gap is trimmed in BarChart). Recount
// if bar spacing in _base_barchart_ui_configs or WIDGET_MAX_HEIGHT changes.
export const DEFAULT_MAX_BARS = 16;

// Minimum the stepper allows. One bar plus "Others" is a valid chart, matching
// the pie chart's floor.
export const MIN_BARS = 1;
